/* eslint-disable */
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import lockr from 'lockr';
import { notification } from 'antd';
import { isUndefined } from 'underscore';
import { persistor } from "../store";
import { logoutUser } from "../user/userApi";
import NotFound from '../../pages/NotFound';
import constants from '../constants';
import { isSessionExpired, clearSessionAuth } from './session';
import { AppDispatch, CombinedStates, ProtectedRouteProps } from '../types';

interface RouteItem {
    path: string;
    component: React.ComponentType<any>;
    type?: string;
    role?: string;
    allowedOnlyRoles?: string[];
}

interface CoreRouterProps {
    routes: RouteItem[];
}

interface LogoutRouteProps {
    path: string;
    exact: boolean;
    persistor: any; // Replace 'any' with the correct type for your persistor
}

const {
    AUTH_KEY,
} = constants;

const onlyAuthorisedAllowed = ():boolean => {
    if (isUndefined(lockr.get(AUTH_KEY))) {
        return false;
    }
    // Enforce both the idle (inactivity) and absolute (since-login) timeouts.
    if (isSessionExpired()) {
        notification.error({ message: 'Error', description: 'Session expired. Please login again.' });
        return false;
    }
    return true;
};

const ProtectedRoute = ({ children }:ProtectedRouteProps) => {
    if (onlyAuthorisedAllowed()) {
        return <>{children}</>;
    }
    const dispatch = useDispatch<AppDispatch>();
    dispatch(logoutUser());
    return <Navigate to="/" />;
}

const cleanUpLocalStorage = () => {
    // clearSessionAuth() already wipes localStorage (and therefore all lockr
    // keys), so no separate lockr.flush() is needed here.
    clearSessionAuth();
    persistor.flush();
    persistor.purge();
    window.location.href = '/';
    return null;
};

const LogoutRoute:React.FC<LogoutRouteProps> = ({ exact, path, persistor }) => {
    return cleanUpLocalStorage();
}

const CoreRouter: React.FC<CoreRouterProps> = ({ routes }) => {
    const { userData } = useSelector((state: CombinedStates) => state.user);
    return (
        <Routes>
            {routes.map((route, index) => {
                let element = <route.component/>;
                if (route.type === 'auth') {
                    if ((route.allowedOnlyRoles && route.allowedOnlyRoles.includes(userData.role.accessLevel))
                    || (route.role === userData.role.accessLevel)) {
                        element = <ProtectedRoute>
                            <route.component/>
                        </ProtectedRoute>;
                    } else {
                        element = <Navigate to="/" />;
                    }
                }
                return <Route
                    key={index}
                    // exact
                    path={route.path}
                    element={element} />;
                }
            )}
            <Route element={<NotFound />} />
        </Routes>
    );
};

export {
    CoreRouter,
    onlyAuthorisedAllowed,
    LogoutRoute,
    LogoutRouteProps,
};
